/**
 * Shared layout constants — single source of truth for structural dimensions
 * referenced across multiple components.
 */

/** Height of the fixed top navbar (NavbarContainer max-height in Navbar.styled.tsx). */
export const NAVBAR_HEIGHT_PX = 60
